import { Stack } from "@mantine/core";
import PageContent from "components/layouts/PageContent";
import PageHeader from "components/layouts/PageHeader";
import { FC } from "react";

import UserTable from "./components/UserTable/UserTable";
import GroupButton from "components/ui/GroupButton";
import UserActions from "./components/UserActions/UserActions";
import { useUsers } from "utils/hooks";
import { useTableParams } from "utils/hooks/common/useTableParams";

const USER_PAGE_TITLE = "Qu\u1ea3n l\u00fd ng\u01b0\u1eddi d\u00f9ng";

const UserListWebLayout: FC = () => {
  const { params, handlePageChange, handleLimitChange, handleSearch } =
    useTableParams();

  return (
    <Stack gap="sm">
      <PageHeader breadcrumbs={[{ title: USER_PAGE_TITLE, href: "" }]} />
      <PageContent>
        <Stack gap="xs">
          <UserActions handleSearch={handleSearch} params={params} />
          <UserTable
            params={params}
            onPageChange={handlePageChange}
            onLimitChange={handleLimitChange}
          />
        </Stack>
      </PageContent>
    </Stack>
  );
};

export default UserListWebLayout;
